// extracted by mini-css-extract-plugin
export default {"container":"Uzdu94","mobileContainer":"lgW0si","overlay":"PnUuFo","svgContainer":"X8YxNy"};